import { Component, Input, OnInit } from '@angular/core';
import { PieChartConfig } from '../../../../../shared/google-chart/Models/PieChartConfig';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import * as moment from 'moment';

@Component({
  selector: 'app-plink-alerts',
  templateUrl: './plink-alerts.component.html',
  styleUrls: ['./plink-alerts.component.css']
})
export class PlinkAlertsComponent implements OnInit {

  @Input() data: any;
  @Input() siteId: number = 0;
  @Input() customerId: number = 0;
  @Input() sitePlinksData: any = {};
  @Input() siteTags: any = {};
  @Input() sitePlinksTags: any = {};
  @Input() customerName: string = '';
  @Input() siteName: string = '';

  config: PieChartConfig;
  filteredData: any;
	tableColumns: any[] = [
		{title: "PolarLink ID", property: "rseId"},
		{title: "PolarLink SN", property: "serialnumber"},
	];
  title: string = 'Site Alerts';
  tooltipText: string = 'Visual breakdown of system alerts by type (e.g., fault latching, over current, over voltage). Larger segments indicate higher frequency.';
  elementId: string = 'plinks-alerts';
  widgetClass: string = 'auto-height-widget';
  siteWidgetOptions: any = {
    hasOperation: false,
    hasChargerModels: false,
    hasDate: true,
    isSitePerformanceWidget: true,
    isChargers: false,
    isPlink: true,
    hideYesterdayDate: true,
    filterOutZeroValues: true,
    excludeSinceInstallationOption: true
  };
  
  constructor(private commonUtil: CommonUtil){};

  ngOnInit() {

    this.config = new PieChartConfig({
		chartArea: {width: "80%", height: "80%", left: "5%", top: "5%", right: "5%"},
		pieHole: 1,
		pieSliceText:'none',
		height: 350, // Increased height to accommodate labels
		legend: {
		position: 'labeled',
		textStyle: {
			fontSize: 12
		},
		maxLines: 2, // Allow up to 2 lines for labels
		alignment: 'center',
		labeledValueText: 'both' // Show both label and value
		},
			colors: [
				{ color: '#32336c' },
				{ color: '#2d5e96' },
				{ color: '#238ab7' },
				{ color: '#32b8d3' },
				{ color: '#60e6e9' },
				{ color: '#238ab7' },
				{ color: '#32336c' },
				{ color: '#2d5e96' },
				{ color: '#238ab7' },
				{ color: '#724d83' },
			]

		});

		this.config.formatFunction = (data: any) => {
      const {faultLatching, faultNonLatching, faultRelayAux, overCurrent, overFreq, overVoltage, underCurrent, underFreq, underVoltage} = data || {};
      const allEmpty = Object.values({faultLatching, faultNonLatching, faultRelayAux, overCurrent, overFreq, overVoltage, underCurrent, underFreq, underVoltage}).every(arr => Array.isArray(arr) && arr.length === 0);
			if(allEmpty) return [];
			let formattedData: any[] = [
				[
					{"label": "Name", "type": "string"},
					{"label": "Value", "type": "number"},
					{"type": "string", role: 'annotation'},
					{"type": "string", role: 'style'},
				]
			];

      for(let key in data){
        const item = data[key];
        if(!item.length) continue;
        formattedData.push(
					[
						{v: item[0].fault},
						{v: item.length},
						{v: ''},
            {v: 'color: #bd2f26' }
					]
				);
      }
			return formattedData;
		};
  }

  eventEmit(event: {type: string, data: any}) {
  
    switch (event.type) {
      case "export":
        let exportFilters: any = this.commonUtil.getExportWidgetFiltersInfo(event.data);
        let csvData: any = [{
          a: 'Site: '+this.customerName+'/'+this.siteName
        }];
        for(let key in exportFilters) {
          csvData.push({a: exportFilters[key]});
        }
        csvData.push({a: 'Date of print: '+ moment().format('LL')}, {}); // Date of print & an empty row
        csvData.push({a: "PolarLink ID", b: "PolarLink SN", c: "Fault"});
        for(let range in this.filteredData) {
          let devices = this.filteredData[range];

          if(devices){
            devices.forEach((device: any) => {
              csvData.push({a: device.rseId, b: device.serialnumber, c: device.fault});
            });
          }
        }

        let fileName = `${this.title} - ${this.customerName} / ${this.siteName}`;
        new ngxCsv(csvData, fileName);
        break;

      case "filteredData":
        this.filteredData = event.data;
        break;
    }
  }
}
